import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.d8{position:fixed;}.ssr-plugin'
import '.ay{width:100vw;}.ssr-plugin'
import '.cg{height:100dvh;}.ssr-plugin'
import '.b9{inset:0px;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.eg{z-index:3;}.ssr-plugin'
import '.eh{animation:modal-backdrop-in 0.4s ease-out both;}.ssr-plugin'
import { useEffect } from 'react'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'

export const MODAL_PANEL_ANIMATION =
  'modal-panel-in cubic-bezier(0.22, 1, 0.36, 1) 400ms both'

type ModalWrapperProps = {
  onDismiss?: () => void
  children: React.ReactNode
  style?: Style
}

export const ModalWrapper = ({
  onDismiss,
  children,
  style,
}: ModalWrapperProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return (
    <styled.div className="e w cy d8 ay cg b9 ee ef eg eh"
      style={{
        backgroundColor: `${transparentColor(colors.secondary, 0.5)}`,
        [MOBILE]: {
          backgroundColor: `${transparentColor(colors.secondary, 1)}`,
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none',
        },
        ...style,
      }}
      onClick={onDismiss}
    >
      {children}
    </styled.div>
  )
}
